import React from 'react'
import { withRouter } from 'react-router-dom';

import * as routes from '../../config/routes';
import * as api from '../../api'

import { auth } from '../../firebase';


const byPropKey = (propertyName, value) => () => ({
    [propertyName]: value,
  });

const INITIAL_STATE = {
  username: '',
  email: '',
  passwordOne: '',
  passwordTwo: '',
  error: null,
};

class SignUpPage extends React.Component {
  constructor(props) {
    super(props);
    this.setState({role: props.role}) 
  }

  onSubmit = (event) => {
  	const {
      email,
      passwordOne,
      passwordTwo,
      role
    } = this.state;

    const {
      history,
    } = this.props;

    if (passwordOne !== passwordTwo) {
      this.setState(byPropKey('error', {message: "Passwords should match."}))
    } else {
      auth.doCreateUserWithEmailAndPassword(email, passwordOne)
        .then(authUser => {
          var data = {
            uid: authUser.user.uid, 
            email: email, 
            role: this.state.role
          }
          api.makeApiPost(routes.API_SAVE_USER, data)

          this.setState(() => ({ ...INITIAL_STATE }));
        	history.push(routes.LANDING);
        })
        .catch(error => {
          this.setState(byPropKey('error', error));
        });
    }

    event.preventDefault();
  }

  render() {

  	const {
      email,
      passwordOne,
      passwordTwo,
      error,
    } = this.state;

    const roleLabel = this.state.role ? (
      <h4> Join as a {this.state.role} </h4>
    ) : (
      <p></p>
    );

    return (
      <div>
        <div className="container">
          <div className="section">
            <div className="row">
              <div className="col s12 m4">
                <div className="page-transitions">
                <div id="page-content">
          	    <div className="page-fullscreen">
          	        <div className="page-fullscreen-content">
          	            <div className="pageapp-login">
          	                <a className="page-logo"></a>

                            {roleLabel}
          	              
          	              	<form onSubmit={this.onSubmit}>
                   
          	                <div className="pageapp-login-input">
          	                    <i className="login-icon ion-at"></i>
          	                    <input required type="text" placeholder="Email Address" value={email}
                    					onChange={event => this.setState(byPropKey('email', event.target.value))}
          	                    />
          	                </div>                     
                       
          	                <div className="pageapp-login-input full-bottom">
          	                    <i className="login-icon ion-locked"></i>
          	                    <input required type="password" placeholder="Password" value={passwordOne}
                    					onChange={event => this.setState(byPropKey('passwordOne', event.target.value))}
          	                    />
          	                </div>
          	                <div className="pageapp-login-input full-bottom">
          	                    <i className="login-icon ion-locked"></i>
          	                    <input required type="password" placeholder="Confirm Password" value={passwordTwo}
                    					onChange={event => this.setState(byPropKey('passwordTwo', event.target.value))}
          	                    />
          	                </div>

          		            { error && <p>{error.message}</p> }
          	                <a onClick={this.onSubmit} className="button button-green button-icon button-full half-top half-bottom"><i className="ion-log-in"></i>Create Account</a>
                            <br />
          	                <a href={routes.SIGN_IN} className="button button-blue button-icon button-full half-top full-bottom"><i className="ion-person"></i>Sign In Here</a>
          	            	</form>
          	            </div>
          	        </div>
          	        <div className="overlay dark-overlay"></div>
          	    </div>  
                </div>
          	  </div>
            </div>
            </div>
          </div>
        </div>
    </div>
    );
  }
}

export default withRouter(SignUpPage);



// WEBPACK FOOTER //
// ./src/components/identity/SignUp.js